export class ScanCode {
  code = ''
  lastTime = 0
  success = () => {}
  fail = () => {}

  constructor(options) {
    this.success = options.success
    this.fail = options.fail
  }

  /**
   * 扫码回调
   */
  getScanCode(e) {
    // e.preventDefault() // 防止按下回车键触发外层button的点击事件
    try {
      const { key, keyCode } = e
      // Shift键
      if (keyCode === 16) {
        return
      }
      // 键入Enter(扫码结束)
      if (keyCode === 13) {
        const code = this._formatCode(this.code)
        this._handleSuccess(code)
        this.code = '' // 清空值
        return
      }
      const nextTime = new Date().getTime()
      // 两次输入间隔大于300ms, 重新拼接code
      if (this.lastTime && nextTime && nextTime - this.lastTime > 200) {
        console.log(
          '两次输入间隔大于200ms, 重新拼接code',
          '间隔' + (nextTime - this.lastTime),
          'key=' + key,
          'code=' + this.code
        )
        this.code = key
      } else {
        this.code += key
      }
      this.lastTime = nextTime
    } catch (e) {
      this._handleFail(e)
      console.error('扫码失败', e)
    }
  }

  /**
   * 监听扫码
   */
  addScanCodeListener() {
    document.onkeydown = this.getScanCode.bind(this)
  }

  /**
   * 取消监听扫码
   */
  removeScanCodeListener() {
    document.onkeydown = null
  }

  /**
   * 扫码成功
   * @param {String} code 扫码结果
   * @private
   */
  _handleSuccess(code) {
    if (this.success && typeof this.success === 'function') {
      this.success(code)
    }
  }

  /**
   * 扫码失败
   * @param e
   * @private
   */
  _handleFail(e) {
    if (this.fail && typeof this.fail === 'function') {
      this.fail(e)
    }
  }

  _formatCode(code) {
    if (!code) {
      return ''
    }
    console.log('原code', code)
    let formattedCode = code.toLowerCase()
    formattedCode = formattedCode.replace(/capslock/gi, '')
    formattedCode = formattedCode.replace(/meta/gi, '')
    formattedCode = formattedCode.replace(/tab/gi, '')
    console.log('格式化后code', formattedCode)
    return formattedCode
  }
}
